/**
 * @description 键盘鼠标输出管理
 *              注意：除了键盘按下和抬起事件是整个窗口的，其它事件都只属于3D窗口 ！！！！！
 * @author TKB
 * @creat 2024-01-02 17:40:27
 */
import { BaseManager } from "./BaseManager.js";
import { EventManagerCommand } from "./EventManager.js";

export class InputManager extends BaseManager {
  constructor(manager) {
    super(manager);
  }

  init(manager) {
    super.init(manager);

    if (this.manager.sceneManager) {
      this.renderer = this.manager.sceneManager.renderer;
      this._addListener();
    } else if (this.manager.eventManager) {
      this.manager.eventManager.addEventListener(
        EventManagerCommand.sceneManagerInitCompleted,
        () => {
          this.renderer = this.manager.sceneManager.renderer;
          this._addListener();
        }
      );
    }
  }

  update(dt) {
    super.update(dt);
  }

  clear() {
    this._removeListener();

    super.clear();
  }

  _onKeyDown(event) {
    //event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.keyDown, event);
  }

  _onKeyUp(event) {
    //event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.keyUp, event);
  }

  _resize() {
    //event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.resize);
  }

  _onMouseDown(event) {
    event.preventDefault();

    // 新增强制失焦逻辑，作用为点击到3D容器时让UI元素失去焦点
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }

    this.manager.eventManager.dispach(EventManagerCommand.pointerDown, event);
  }
  _onMouseUp(event) {
    event.preventDefault();

    //避免单击双击冲突
    if (this.clickFlag) {
      clearTimeout(this.clickFlag);
      this.clickFlag = null;
    }
    this.clickFlag = setTimeout(() => {
      this.manager.eventManager.dispach(EventManagerCommand.pointerUp, event);
    }, 270);
  }
  _onDBlclick(event) {
    event.preventDefault();

    //避免单击双击冲突
    if (this.clickFlag) {
      clearTimeout(this.clickFlag);
      this.clickFlag = null;
    }

    this.manager.eventManager.dispach(EventManagerCommand.dblClick, event);
  }
  _onMouseMove(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.pointerMove, event);
  }

  _onPointDrop(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand._onPointDrop, event);
  }

  _onTouchStart(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.touchstart, event);
  }

  _onTouchEnd(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.touchend, event);
  }

  _onTouchCancel(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.touchcancel, event);
  }

  _onTouchLeave(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.touchleave, event);
  }

  _onMouseDrop(event) {
    event.preventDefault();
    this.manager.eventManager.dispach(EventManagerCommand.mouseDrop, event);
  }

  _addListener() {
    //在 JavaScript 中，bind 方法返回一个新的函数。因此，
    //this._onKeyDown.bind(this) 在每次调用时都会返回一个不同的函数
    // 所以需要保存 bind 方法的返回值
    this.onKeyDownFunc = this._onKeyDown.bind(this);
    this.onKeyUpFunc = this._onKeyUp.bind(this);
    this.resizeFunc = this._resize.bind(this);
    this.pointerDownFunc = this._onMouseDown.bind(this);
    this.pointerUpFunc = this._onMouseUp.bind(this);
    this.onDBlclickFunc = this._onDBlclick.bind(this);
    this.onMouseMoveFunc = this._onMouseMove.bind(this);
    this.onTouchStartFunc = this._onTouchStart.bind(this);
    this.onTouchEndFunc = this._onTouchEnd.bind(this);
    this.onTouchCancelFunc = this._onTouchCancel.bind(this);
    this.onTouchLeaveFunc = this._onTouchLeave.bind(this);
    this.onMouseDropFunc = this._onMouseDrop.bind(this);

    window.addEventListener("keydown", this.onKeyDownFunc, false);
    window.addEventListener("keyup", this.onKeyUpFunc, false);
    window.addEventListener("resize", this.resizeFunc, false);
    this.renderer.domElement.addEventListener(
      "pointerdown",
      this.pointerDownFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "mousedown",
      this.pointerUpFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "pointerup",
      this.pointerUpFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "mouseup",
      this.pointerUpFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "dblclick",
      this.onDBlclickFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "pointermove",
      this.onMouseMoveFunc,
      false
    );

    this.renderer.domElement.addEventListener(
      "touchstart",
      this.onTouchStartFunc,
      false
    );

    this.renderer.domElement.addEventListener(
      "touchend",
      this.onTouchEndFunc,
      false
    );

    this.renderer.domElement.addEventListener(
      "touchcancel",
      this.onTouchCancelFunc.bind(this),
      false
    );

    this.renderer.domElement.addEventListener(
      "touchleave",
      this.onTouchLeaveFunc,
      false
    );

    this.renderer.domElement.addEventListener(
      "drop",
      this.onMouseDropFunc,
      false
    );
  }

  _removeListener() {
    window.removeEventListener("keydown", this.onKeyDownFunc, false);
    window.removeEventListener("keyup", this.onKeyUpFunc, false);
    window.removeEventListener("resize", this.resizeFunc, false);
    this.renderer.domElement.removeEventListener(
      "pointerdown",
      this.pointerDownFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "mousedown",
      this.pointerUpFunc,
      false
    );
    this.renderer.domElement.removeEventListener(
      "pointerup",
      this.pointerUpFunc,
      false
    );
    this.renderer.domElement.addEventListener(
      "mouseup",
      this.pointerUpFunc,
      false
    );
    this.renderer.domElement.removeEventListener(
      "dblclick",
      this.onDBlclickFunc,
      false
    );
    this.renderer.domElement.removeEventListener(
      "pointermove",
      this.onMouseMoveFunc,
      false
    );

    this.renderer.domElement.removeEventListener(
      "touchstart",
      this.onTouchStartFunc,
      false
    );
    this.renderer.domElement.removeEventListener(
      "touchend",
      this.onTouchEndFunc,
      false
    );

    this.renderer.domElement.removeEventListener(
      "touchcancel",
      this.onTouchCancelFunc,
      false
    );

    this.renderer.domElement.removeEventListener(
      "touchleave",
      this.onTouchLeaveFunc,
      false
    );

    this.renderer.domElement.removeEventListener(
      "drop",
      this.onMouseDropFunc,
      false
    );

    this.onKeyDownFunc = null;
    this.onKeyUpFunc = null;
    this.resizeFunc = null;
    this.pointerDownFunc = null;
    this.pointerUpFunc = null;
    this.onDBlclickFunc = null;
    this.onMouseMoveFunc = null;
    this.onTouchStartFunc = null;
    this.onTouchEndFunc = null;
    this.onTouchCancelFunc = null;
    this.onTouchLeaveFunc = null;
    this.onMouseDropFunc = null;
  }
}
